export const endpoints = {
    LOGIN: `${process.env.REACT_APP_LOGIN_API_URL}/Connection/Login`,
    USER: '/api/user',
    GET_PRIZES: `${process.env.REACT_APP_API_URL}/api/Jogos/GetPrizes`,
    GET_RESULTS: `${process.env.REACT_APP_API_URL}/api/Jogos/GetTodayResultPage`,
    EMBUDO_GET_RESULTS: `${process.env.REACT_APP_API_URL}/api/Funnel/GetTodayResultPage`,
    EXTERNALLOTTERIES_GET_RESULTS: `${process.env.REACT_APP_API_URL}/api/Jogos/GetExternalLotteryResult`
  };
  